import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "device-details page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_device_details_header = _resolveComponent("device-details-header")!
  const _component_device_details_information = _resolveComponent("device-details-information")!
  const _component_device_details_overview = _resolveComponent("device-details-overview")!
  const _component_n_tab_pane = _resolveComponent("n-tab-pane")!
  const _component_device_details_network = _resolveComponent("device-details-network")!
  const _component_device_details_history = _resolveComponent("device-details-history")!
  const _component_device_details_data = _resolveComponent("device-details-data")!
  const _component_n_tabs = _resolveComponent("n-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_device_details_header),
    _createVNode(_component_device_details_information),
    _createVNode(_component_n_tabs, {
      size: "large",
      class: "device-information-abs",
      type: "bar",
      animated: "",
      "pane-wrapper-style": "margin: 0 -4px",
      "pane-style": "padding-left: 4px; padding-right: 4px; box-sizing: border-box;"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_tab_pane, {
          class: "device-details-tab",
          name: "overview",
          tab: _ctx.$t('device_details.overview.title'),
          "display-directive": "if"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_device_details_overview)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["tab"]),
        _createVNode(_component_n_tab_pane, {
          class: "device-details-tab",
          name: "network",
          tab: _ctx.$t('device_details.network.title'),
          "display-directive": "if"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_device_details_network)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["tab"]),
        _createVNode(_component_n_tab_pane, {
          class: "device-details-tab",
          name: "history",
          tab: _ctx.$t('device_details.history.title'),
          "display-directive": "if"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_device_details_history)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["tab"]),
        _createVNode(_component_n_tab_pane, {
          class: "device-details-tab",
          name: "data",
          tab: _ctx.$t('device_details.data.title'),
          "display-directive": "if"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_device_details_data)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["tab"])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}